import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { ExportCallsPayload, MyDevelopmentService } from '../../../services/my-development.service';
import { NapiService } from 'src/app/services/napi.service';
import { WsPayload } from '../../../models/payload.model';
import { Subscription } from 'rxjs';
import { Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-calls-export',
  templateUrl: './calls-export.component.html',
  styleUrls: ['./calls-export.component.scss'],
})
export class CallsExportComponent implements OnInit, OnDestroy {
  @Input() public getPayload!: (includeTeams: boolean) => Promise<ExportCallsPayload>;
  @Input() isIncludeTeams = false;
  @Output() valueChange = new EventEmitter<{ key: string; values: Record<string, any> }>();

  public groupByAgents = false;
  public includeTeams = false;
  private socket: Socket = null;
  private currentJobId: string | null = null;
  private exportSubscription: Subscription | null = null;

  constructor(
    private myDevelopmentService: MyDevelopmentService,
    private napiService: NapiService
  ) {}

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.cleanupWebSocket();
    this.exportSubscription?.unsubscribe();
    this.exportSubscription = null;
  }

  public async exportCalls(): Promise<void> {
    await this.initWebSocket();

    const payload = await this.getPayload(this.includeTeams);

    this.exportSubscription?.unsubscribe();
    this.exportSubscription = this.myDevelopmentService
      .exportCalls(this.groupByAgents, payload)
      .subscribe((value) => {
        console.log('value', value);
        this.currentJobId = value.jobId;
    });
  }

  changeIncludeTeams() {
    this.includeTeams = !this.includeTeams;
    this.valueChange.emit({ key: 'includeTeams', values: { includeTeams: this.includeTeams } });
  }

  private async initWebSocket(): Promise<void> {
    if (!this.socket) {
      this.socket = this.napiService.socket('global');

      this.socket.on('connect', () => {
        console.log('Socket connected');
        this.socket.emit('joinToGlobal');
      });

      this.socket.on('GlobalEvents', (payload: WsPayload) => {
        console.log('got GlobalEvents →', payload);
        this.handleInteractionMessage(payload);
      });

      this.socket.on('disconnect', () => {
        console.log('Socket disconnected');
      });

      await new Promise<void>((resolve) => {
        this.socket.once('connect', () => resolve());
      });
    }
  }

  private cleanupWebSocket(): void {
    if (this.socket) {
      this.socket.off('GlobalEvents');
      this.socket.off('connect');
      this.socket.off('disconnect');
      this.socket.disconnect();
      this.socket = null;
      console.log('WebSocket cleaned up');
    }
    this.currentJobId = null;
  }

  private handleInteractionMessage(evt: WsPayload): void {
    console.log('📬 handleInteractionMessage got:', evt);

    if (this.currentJobId && evt.data.jobId !== this.currentJobId) {
      console.log(`Ignoring event for jobId ${evt.data.jobId}, current jobId is ${this.currentJobId}`);
      return;
    }

    switch (evt.message) {
      case 'callAiReportComplete':
        this.onReportComplete(evt.data);
        break;

      default:
        console.warn('Unhandled WS message:', evt.message);
    }
  }

  private onReportComplete(data: { jobId: string; url: string }): void {
    const fileUrl = environment.websiteUrl + '/' + data.url;

    fetch(fileUrl, { mode: 'cors' })
      .then((res) => {
        if (!res.ok) {throw new Error(`HTTP ${res.status}`);}
        return res.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = `call-report-${data.jobId}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(blobUrl);
        this.currentJobId = null;
      })
      .catch((err) => {
        console.error('Download failed', err);
        this.currentJobId = null;
      })
      .finally(() => {
        this.cleanupWebSocket();
        this.exportSubscription?.unsubscribe();
        this.exportSubscription = null;
      });
  }
}
